<div class="fdd-agro-tab">
  @if (loading) {
    <div class="fdd-agro-tab__loader">
      <app-loading [loading]="true"></app-loading>
    </div>
  } @else {
    <app-data-table
      [columns]="tableColumns"
      [data]="rows"
      [config]="tableConfig"
      [totalRecords]="totalRecords"
    ></app-data-table>
  }
</div>

<ng-template #typeTemplate let-row>
  {{ row.operationId | inArrayPipe: measureTypes : translate.currentLang }}
</ng-template>

<ng-template #cropTemplate let-row>
  @let params = row.agroOperationParamsJson | parseJson;
  @if (params?.cropId) {
    {{ params.cropId | inArrayPipe: crops : translate.currentLang }}
  }
</ng-template>
